
<highcharts class="chart" :options="chart" :key="JSON.stringify(data)"></highcharts>
